import { BaseService } from './BaseService'
const GOOGLE_LOGIN_PATH = '/google/login'
/* eslint-disable */ 
class SocialLoginService extends BaseService {
  sendSocialLoginId (name, formData) {
    if (name === 'Google') {
      return this.post(GOOGLE_LOGIN_PATH, formData)
    }
  }
}
export default new SocialLoginService()
/* eslint-disable */ 
